var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnHelp18 = function SvgLightIcnHelp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 2.75a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5M1.75 9a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.993 11.806a.68.68 0 0 0-.495.2.67.67 0 0 0-.204.5.68.68 0 0 0 .203.496.68.68 0 0 0 .496.203q.3 0 .5-.204a.68.68 0 0 0 .2-.496.683.683 0 0 0-.7-.699M11.26 6.023a2.15 2.15 0 0 0-.846-.75 2.7 2.7 0 0 0-1.231-.276c-.492 0-.92.097-1.27.29a2.1 2.1 0 0 0-.822.778 2.5 2.5 0 0 0-.34 1.067l-.014.167h.906l.013-.138c.028-.26.108-.492.238-.688a1.34 1.34 0 0 1 .516-.458q.324-.165.745-.166.426 0 .753.166.325.166.507.453.181.288.182.671 0 .28-.09.51a1.2 1.2 0 0 1-.29.43 3.6 3.6 0 0 1-.554.44c-.261.174-.48.35-.648.525a1.7 1.7 0 0 0-.377.576 1.9 1.9 0 0 0-.118.694v.624h.923v-.517q0-.299.079-.512.076-.21.266-.397a3.5 3.5 0 0 1 .554-.425c.393-.256.698-.546.905-.858q.317-.48.318-1.135c0-.396-.103-.757-.306-1.071",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnHelp18;